const reorderSpeiseplan = (data, datum) => {
    if (!data) return data;
    // Der Speisplan enthält ein Array mit mehreren Wochen
    // Ich möchte, dass die Woche, in der der heutige Tag liegt, an den Anfang kommt
    // und der bisherige Anfang dahinter liegt
    const today = (datum === undefined) ? new Date() : new Date(datum); // das ist nicht Heute 00:00 Uhr sondern jetzt
    // console.log(today)
    today.setHours(0, 0, 0, 0);
    const base = new Date('2022-06-06T00:00:00'); //  06.06.2022'); // das ist das Startdatum 00:00 Uhr ( es muss ein Montag sein )
    base.setHours(0, 0, 0, 0);
    const days = Math.trunc((today - base) / (1000 * 3600 * 24)); // Anzahl der Tage zwischen Start und Heute
    const weeks = Math.trunc(days / 7); // Anzahl der Wochen zwischen Startdatum und Datum (heute)
    const start = (weeks * 7) % data.length; 
    // console.log(datum, today.toLocaleDateString(), base.toLocaleDateString(), days, weeks, start)
    //
    // console.log('reorderSpeiseplan, days, weeks, data.length, start, data', days, weeks, data.length, start, data)
    let newData = [];
    if (data.length >= 14) {
        const rest = data.splice(start);
        newData = rest.concat(data);
    } else {
        // console.log('reorderSpeiseplan Rohdaten', data)
        newData = [...data]
        newData = newData.concat(newData);
        // console.log('reorderSpeiseplan concatenated', newData)
    }
    const corrArray = newData.map((element, i) => {
        // console.log('reorderSpeiseplan correcting element', i, element)
        return {...element, TAG: i+1}; // korrigiere die TAG Einträge entsprechend
    });
    // console.log('reorderSpeiseplan corrected', corrArray)
    return (corrArray);
}

export default reorderSpeiseplan;